import React, { useState } from 'react';
import { useDrag } from 'react-dnd';
import moment from 'moment';

const InboxData = ({ item, isShiftPressedMail, setIsShiftPressedMail, onItemDrag, onClick, allData }) => {
    const [isHovered, setIsHovered] = useState(false);

    const [{ isDragging }, drag] = useDrag({
        type: isShiftPressedMail ? 'childTask' : 'task',
        item: isShiftPressedMail
            ? {
                isShiftPressed: true,
                item,
                taskForCreate: true,
                typeOf: 'Whatsapp',
            }
            : {
                id: item?.id,
                gmailMessage: item?.id,
                isShiftPressed: false,
                typeOf: 'Whatsapp',
                item,
            },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
        end: (draggedItem, monitor) => {
            if (monitor.didDrop()) {
                onItemDrag(draggedItem);
            }
        },
    });

    const handleContextMenu = (event) => {
        event.preventDefault();
    };
    const colors = [
        'bg-green-500',
        'bg-blue-500',
        'bg-yellow-500',
        'bg-pink-500',
        'bg-purple-500',
        'bg-indigo-500',
        'bg-orange-500',
        'bg-emerald-500',
    ];

    const getColorFromName = (name) => {
        const safeName = name || '';
        const charCodeSum = safeName?.split('')?.reduce((sum, char) => sum + char?.charCodeAt(0), 0);
        return colors[charCodeSum % colors.length];
    };
    const unreadCount =
        Array.isArray(item?.Chats)
            ? item.Chats.filter(c => c.chatStatus === 'unread').length
            : 0;

    return (
        <div
            ref={drag}
            className={`max-w-sm shadow hover:bg-[#FAFAFA] ${item.messageRead === 'unread' ? 'bg-gray-100' : 'bg-white'
                }`}
            style={{
                borderColor: item?.GmailUser?.colour || '#ccc',
                opacity: isDragging ? 0.5 : 1,
                padding: '0.5rem',
            }}
            onContextMenu={handleContextMenu}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div
                className="flex items-center gap-3 p-2 cursor-pointer"
                onClick={onClick}
            >
                {/* Avatar */}
                <div className="flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 text-gray-600 flex-shrink-0">
                    {item?.profileImage && item?.profileImage.trim() !== '' ? (
                        <img
                            src={`${process.env.REACT_APP_IMAGE_URL}/${item?.profileImage}`}
                            alt="profile"
                            className="w-full h-full rounded-full object-cover"
                            onError={e => {
                                e.target.onerror = null;
                                e.target.src = '/default-profile.png';
                            }}
                        />
                    ) : (
                        <i className="fas fa-user text-xl"></i>
                    )}
                </div>

                <div className="flex-1">
                    <div className="flex items-center justify-between">
                        <div className="flex flex-col min-w-0">
                            <h2
                                className={`truncate text-[13px] text-gray-800 ${item.messageRead === 'unread' ? 'font-bold' : 'font-normal'
                                    }`}
                            >
                                {item?.name
                                    ? item?.name
                                    : item?.contactNo?.split('@')[0]?.slice(-10) || 'Unknown'}
                            </h2>

                            <span
                                className={`truncate text-[13px] text-gray-600 ${item.messageRead === 'unread' ? 'font-bold' : 'font-normal'
                                    }`}
                            >
                                {item?.Chats?.length
                                    ? item.Chats[item.Chats.length - 1]?.message
                                    : ''}
                            </span>
                        </div>

                        <div className="flex flex-col items-end leading-none space-y-1">
                            <span
                                className={`text-[11.5px] text-gray-700 ${item.messageRead === 'unread' ? 'font-bold' : 'font-normal'
                                    }`}
                            >
                                {item?.Chats?.length &&
                                    item.Chats[item.Chats.length - 1]?.lastSeen != null &&
                                    item.Chats[item.Chats.length - 1]?.lastSeen !== ''
                                    ? new Date(
                                        item.Chats[item.Chats.length - 1].lastSeen
                                    ).toLocaleTimeString('en-US', {
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        hour12: true,
                                    })
                                    : ''}
                            </span>

                            {unreadCount > 0 && (
                                <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-green-500 text-white text-[11px] font-semibold">
                                    {unreadCount > 99 ? '99+' : unreadCount}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InboxData;
